/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to save Microsoft sign-in settings" |
*
* @param {Microsoft_Tenant_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_save_error = /** @type {((inputs?: Microsoft_Tenant_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für die Microsoft-Anmeldung konnten nicht gespeichert werden")
	return /** @type {LocalizedString} */ ("Failed to save Microsoft sign-in settings")
});